import { useQuery } from "@tanstack/react-query";
import api_public from "../services/newApi/api_public";

export const useFeatureFlag = (key: string) => {
  const { data, isLoading } = useQuery({
    queryKey: ["feature-flags", key],
    queryFn: async () => {
      const response = await api_public.get<{
        status: string;
        data: { key: string; enabled: boolean };
      }>(`/feature-flags/${key}`);
      return response.data.data;
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return {
    enabled: isLoading ? false : (data?.enabled ?? false),
    loading: isLoading,
  };
};
